import React from 'react';
import { ProductCarousel } from './ProductCarousel';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../lib/metaPixel';
export function ProductBonosSection() {
  const bonos = [{
    img: 'https://cdn.magicpatterns.com/uploads/gfW3e4pgq3hbpzobtjEDMh/Bono_1_portada.png',
    title: 'La Lista del Súper Inteligente',
    desc: 'La lista de compras definitiva organizada por pasillos. Ahorra tiempo y dinero cada semana eligiendo solo lo que tu cuerpo necesita.',
    value: '$27 USD'
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/kv8GDgASA96zxq4h5uyQE6/Bono_2_portada.png',
    title: 'Checklist Nocturna Anti-Despertares',
    desc: 'El protocolo de 5 pasos para preparar tu cuerpo y mente antes de dormir. Elimina los despertares a las 3 AM desde la primera noche.',
    value: '$17 USD'
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/wLdjiQkAh5vN8Mf5h44hWr/Bono_3_portada.png',
    title: 'Guía Rápida de Desayunos que Dan Energía',
    desc: 'Porque un buen día empieza la noche anterior. 20 desayunos diseñados para mantener estable tu energía y tu azúcar toda la mañana.',
    value: '$27 USD'
  }];
  return <section className="w-full bg-botanic py-20 px-6 text-white" data-id="element-99">
      <div className="max-w-[1200px] mx-auto" data-id="element-100">
        <h2 className="font-serif text-4xl md:text-5xl text-gold text-center mb-16" data-id="element-101">
          Todo lo que recibes hoy
        </h2>

        <div className="text-center mb-12" data-id="element-102">
          <span className="inline-block bg-white/10 text-ivory border border-white/20 px-4 py-1.5 rounded-full text-sm font-semibold tracking-wide mb-4" data-id="element-103">
            EBOOK DIGITAL · ACCESO INMEDIATO
          </span>
          <h3 className="text-2xl md:text-3xl font-serif mb-2" data-id="element-104">
            365 Cenas que te Ayudan a Soñar
          </h3>
          <p className="text-gold/80 line-through text-lg" data-id="element-105">Valor: $37 USD</p>
        </div>

        <ProductCarousel data-id="element-106" />

        <div className="flex items-center gap-4 my-16 max-w-3xl mx-auto" data-id="element-107">
          <div className="flex-1 h-px bg-gold/30" data-id="element-108"></div>
          <h3 className="text-gold font-bold text-xl tracking-wide" data-id="element-109">
            🎁 + 3 BONOS GRATIS
          </h3>
          <div className="flex-1 h-px bg-gold/30" data-id="element-110"></div>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-6 mb-16" data-id="element-111">
          {bonos.map((b, i) => <motion.div key={i} whileHover={{
          x: 5
        }} className="bg-white/5 border border-white/10 rounded-xl p-6 flex flex-col md:flex-row gap-6 items-center" data-id="element-112">
              <div className="w-full md:w-64 shrink-0 rounded-lg overflow-hidden bg-white/10 flex items-center justify-center" data-id="element-113">
                <img src={b.img} alt={b.title} className="w-full h-auto object-contain" data-id="element-114" />
              </div>
              <div className="flex-1" data-id="element-115">
                <h4 className="text-xl font-bold text-gold mb-2" data-id="element-116">{b.title}</h4>
                <p className="text-ivory/80 mb-4" data-id="element-117">{b.desc}</p>
                <p className="text-sm text-ivory/60" data-id="element-118">
                  Valor: <span className="line-through" data-id="element-119">{b.value}</span>{' '}
                  <span className="text-gold font-bold ml-1" data-id="element-120">GRATIS</span>
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="max-w-2xl mx-auto border-2 border-gold rounded-2xl p-8 text-center bg-black/20" data-id="element-121">
          <p className="text-xl text-ivory/80 mb-2" data-id="element-122">
            Valor total: <span className="line-through" data-id="element-123">$108 USD</span>
          </p>
          <p className="text-3xl md:text-4xl font-bold text-gold mb-8" data-id="element-124">
            Precio de lanzamiento: $9.99 USD
          </p>

          <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-8 text-sm text-ivory/90 mb-8" data-id="element-125">
            <span data-id="element-126">✅ Acceso inmediato</span>
            <span data-id="element-127">✅ Pago único</span>
            <span data-id="element-128">✅ Descarga digital</span>
          </div>

          <motion.a href="https://www.legadosalud.com/cart/42654220582997:1" onClick={trackAddToCart} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block w-full md:w-auto bg-gold text-white font-bold text-xl px-10 py-5 rounded-xl shadow-lg shadow-gold/20 hover:shadow-gold/40 transition-all" data-id="element-129">
            Descárgalo AHORA POR $9.99 →
          </motion.a>
        </div>
      </div>
    </section>;
}